module.exports = __webpack_public_path__ + "img/festival.e497f89e.jpg";